// extracted by mini-css-extract-plugin
export default {"root":"G20D6","icon":"_18oMD","title":"_1rGpq","subtitle":"_3Drih","button":"_2Gu1O"};